import React from "react";
import KidBackground from "../ui/backgrounds/KidBackground";

const BackgroundTest = () => {
  return (
    <div className="min-h-screen bg-[#FFF8E1] relative">
      <KidBackground variant="aurora" intensity={1} />
      
      <div className="relative z-10 p-8">
        <h1 className="text-4xl font-fredoka font-bold text-black mb-4">
          Background Test Page
        </h1>
        <p className="text-lg font-baloo text-black">
          If you can see this text clearly, the background is working!
        </p>
        
        <div className="mt-8 grid grid-cols-1 md:grid-cols-2 gap-4">
          <div className="bg-white p-4 rounded-xl shadow-lg">
            <h2 className="text-xl font-fredoka font-bold text-black">White Card</h2>
            <p className="text-gray-700 font-baloo">This should be clearly visible over the background.</p>
          </div>
          
          <div className="bg-amber-100 p-4 rounded-xl shadow-lg">
            <h2 className="text-xl font-fredoka font-bold text-black">Amber Card</h2>
            <p className="text-gray-700 font-baloo">This should also be clearly visible.</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BackgroundTest;



